module.exports = __webpack_public_path__ + "img/grader-icon4.1a6bc006.png";